import React, { useRef, useState } from 'react';
import styles from './AddClientNotes.module.css';
import { editsClientNotesBd } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
import { useDispatch } from 'react-redux';
import { editsClientNotesRedux } from '../../store/slices/clientsSlice';

export default function AddClientNotes({ client }) {
  const dispatch = useDispatch();
  const [notesText, setNotesText] = useState(client.notes);
  const [loaderPage, setLoaderPage] = useState(false);
  // Потрібно щоб показувати кнопку зберегти в textarea
  const showSaveBtnRef = useRef(false);

  const onChangeTextarea = (textValue) => {
    setNotesText(textValue);
    if (!showSaveBtnRef.current) {
      showSaveBtnRef.current = true;
    }
  };

  const saveNotes = async (client_id, notesText) => {
    setLoaderPage(true);
    const isEditsClientNotesBd = await editsClientNotesBd(client_id, notesText);

    if (isEditsClientNotesBd) {
      dispatch(editsClientNotesRedux({ client_id, notesText }));
    }
    showSaveBtnRef.current = false;
    setLoaderPage(false);
  };

  return (
    <>
      <div className={styles.notes_wrapper}>
        <textarea
          className={styles.textarea}
          value={notesText}
          rows="8"
          placeholder="Примітки..."
          onChange={(e) => onChangeTextarea(e.target.value)}></textarea>
        {showSaveBtnRef.current && (
          <button
            className={styles.notes_save_btn}
            onClick={() => saveNotes(client.client_id, notesText)}>
            Зберегти
          </button>
        )}
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
